export enum OkrViewEventType {
  OKRVIEW_VISITED = "OKRVIEW_VISITED",
  OKRVIEW_DELETED = "OKRVIEW_DELETED",
  OKRVIEW_UPDATED = "OKRVIEW_UPDATED",
}
